// @flow
import React from 'react';
import logger from '../../utils/clientLogger';
import Oops from './FallbackComponent';

import {ErrorReportBoundary} from '@homeaway/react-error-reporter';

import type {Node} from 'react';

export const OOPS_ERROR_NAME = 'Oops unable to load results';
type Props = {
    children: Node
};

export default function ErrorBoundary({children}: Props) {
    return (
        <ErrorReportBoundary
            fallbackUI={<Oops />}
            name={OOPS_ERROR_NAME}
            onError={(error, info) => {
                logger.captureException(error, {extra: info});
            }}
        >
            {children}
        </ErrorReportBoundary>
    );
}
